import React from "react";
import { MdExpandMore } from "react-icons/md";
import "./EASelect.scss";

interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface IProps {
  label: string;
  name: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: SelectOption[];
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  placeholder?: string;
}

const EASelect: React.FC<IProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  disabled = false,
  error = false,
  success = false,
  fullWidth = false,
  helperText = "",
  placeholder = "Wybierz opcję...",
}) => {
  return (
    <div className={`custom-select ${fullWidth ? "full-width" : ""}`}>
      <label className={`custom-select__label ${disabled ? "disabled" : ""}`} htmlFor={name}>
        {label}
      </label>
      <div className={`custom-select__select-wrapper ${error ? "error" : ""} ${success ? "success" : ""}`}>
        <select
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="custom-select__select"
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="custom-select__arrow">
          <MdExpandMore />
        </div>
      </div>
      {helperText && (
        <p className={`custom-select__helper-text ${error ? "error" : ""} ${success ? "success" : ""}`}>
          {helperText}
        </p>
      )}
    </div>
  );
};

export default EASelect; 